var runtime = require("../../../../../../../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"title":"_2HcTh"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._2HcTh{margin-bottom:20px;font-size:30px;text-align:center}@media (max-width:599px){"+wrap+" ._2HcTh{font-size:24px}}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

